module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Dedicated")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "dedit"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("to those who struggle to know trust")])]), _vm._v(" "), _c('p', {
    staticClass: "dedit1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("and to find the place of heart.")])])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3119f11e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 69
// module chunks = 0